var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-offices" },
    [
      _c("div", { staticClass: "m-offices__slider__title" }, [
        _vm._v(" FILTER PROPERTIES")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-offices__slider__container" }, [
        _c("div", { staticClass: "m-offices__slider__column" }, [
          _c("div", { staticClass: "m-offices__slider__column__title" }, [
            _vm._v("BY SIZE OF SPACE IN SQ FT")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-offices__slider__filter" },
            [
              _c("vue-slider", {
                attrs: { interval: 250, max: this.maxSqft },
                model: {
                  value: _vm.sqft,
                  callback: function($$v) {
                    _vm.sqft = $$v
                  },
                  expression: "sqft"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "m-offices__slider__seperator" }, [
          _vm._v("\n      OR\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "m-offices__slider__column" }, [
          _c("div", { staticClass: "m-offices__slider__column__title" }, [
            _vm._v("BY NUMBER OF PEOPLE IN YOUR WORKFORCE")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-offices__slider__column__title--small" },
            [
              _vm._v(
                "Allowing 100 sq.ft. per person excluding meeting rooms, breakout space etc"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-offices__slider__filter" },
            [
              _c("vue-slider", {
                attrs: { max: this.maxPeople },
                model: {
                  value: _vm.people,
                  callback: function($$v) {
                    _vm.people = $$v
                  },
                  expression: "people"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-offices__slider__reset" }, [
        _c(
          "div",
          {
            staticClass: "m-readmore",
            on: {
              click: function($event) {
                _vm.sqft = 1
                _vm.people = 1
              }
            }
          },
          [_vm._v("\n      CLEAR FILTERS\n    ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "m-offices__container",
          attrs: { tag: "div", name: "m-offices__container" }
        },
        _vm._l(_vm.activeOffices, function(office) {
          return _c("div", { key: office.ID, staticClass: "m-offices__item" }, [
            _c(
              "a",
              { staticClass: "m-offices__image", attrs: { href: office.URL } },
              [
                _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    "data-src": office.thumbnailSrc,
                    "data-srcset": office.thumbnailSrcSet
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "m-offices__title", attrs: { href: office.URL } },
              [_vm._v("\n\t" + _vm._s(office.post_title) + "\n      ")]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "m-offices__text",
              domProps: { innerHTML: _vm._s(office.text) }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "m-offices__button m-readmore",
                attrs: { href: office.URL }
              },
              [_vm._v("\n\tMORE\n      ")]
            )
          ])
        })
      ),
      _vm._v(" "),
      _vm.activeOffices.length == 0
        ? _c("div", { staticClass: "m-offices__empty" }, [
            _vm._v(
              "\n    Sorry, there are no offices that meet your criteria.\n  "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }